// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getPathTo(element: any): any {
  if (element?.tagName === 'HTML') return '/HTML[1]'
  if (element === document.body) return '/HTML[1]/BODY[1]'

  let ix = 0
  const siblings = element?.parentNode?.childNodes
  for (let i = 0; i < (siblings?.length || 0); i++) {
    const sibling = siblings?.[i]
    if (sibling === element)
      return (
        getPathTo(element?.parentNode) +
        '/' +
        element.tagName +
        '[' +
        (ix + 1) +
        ']'
      )
    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) ix++
  }
}
